import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const fullDescription = `SECTION 3: More Clauses and Contingencies

Most purchase contracts for residential real estate will allow both parties time to review certain documents to determine their desire to move forward. While the seller typically has limited review options, the buyer is often allowed a pre-determined period to review numerous items, including but not limited to:

• Finance options
• Community and homeowner's association documents
• Title and escrow procedures
• Insurance options and possible obligations (such as flood insurance)
• Property condition and issues included value, zoning, land use, etc.
• Seller's disclosure forms such as the Seller's Property Disclosure Statement (SPDS) and/or the Affidavit of Disclosure.
• Inspection reports ordered by the buyer or possibly provided by the seller
• Appraisal report ordered by the lender or obtained by the buyer

As part of a typical real estate transaction, the parties will select a title/escrow company to service the transaction. That company will create and handle all the title transfer forms, accept the funds needed to close the transaction and disperse all funds in accordance with the instructions from the parties.

One of the functions that the title/escrow company will provide is title insurance. Some title companies write title insurance while others will obtain title insurance from other vendors. Title insurance is just what the name infers; it is insurance. A company will need to underwrite that risk and insure the title to the purchaser.

Once the parties have executed a contract and opened escrow, the title company has a title examiner review the transaction, the previous transfers, how title is currently held, how title will be transferred, and as a result, will write a "Commitment for Title Insurance". The commitment will be included in what is known as the Preliminary Title Report, or Pre-lim. That report will identify the transaction, state what is required for title to transfer, and what is exempt from title insurance.

The Residential Purchase contract allows the buyer 5 days to review the Pre-Lim and decide if they want to move forward.

[Question(1823)]

No, the Preliminary Title Report, (Pre-Lim) is generated by the title company and is provided to the buyer (and other parties) once the title work is done and the title company is prepared to transfer title and issue title insurance. Once the buyer receives the pre-lim from the title company, they could cancel the contract for several reasons. The pre-lim might show;

• The encumbrances and liens against the property (that would need to be paid off in order to close) far exceed the sales price
• There is an easement or a setback that the buyer was not aware of
• There is a disclosure of a court order indicating that court approval is still needed (such as probate or divorce court)

Any of the above reasons might cause a buyer to desire to cancel the contract.

In addition to the pre-lim, the package from the title company might include some HOA documents, especially any that are recorded with the title. Such documents, including the Covenants, Conditions and Restrictions (CC&R's) will inform the buyer of the rules under the HOA. While the HOA addendum might allow the buyer a later time to cancel due to their review of the CC&Rs, the buyer would be within their rights to cancel at this time if the CC&Rs contain a clause that they object to. Such clauses might be:

• Limit on the breed, weight and number of dogs
• Restrictions on animals kept as pets (such as a boa constrictor, pigs, etc.)
• Restrictions on parking vehicles in certain areas, on the driveway, in the street and even the number and type of vehicles
• Requirements not allowing basketball hoops and other sports fixtures visible on the property
• Restrictions on the exterior color of the property
• Requirements to maintain areas of landscaping`;
export function ViewCourseSection() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  return <div className="space-y-4" data-id="element-2541" data-mp="3cyt08kb6qrr3">
      <div className="flex items-center justify-between" data-id="element-2542" data-mp="3czm67j2bld86">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2543" data-mp="3hxnuqjiim4r1">Section</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/sections')} data-id="element-2544" data-mp="3hwuqpqaxxtcl">
          ← Back to Sections
        </Button>
      </div>

      <Card data-id="element-2545" data-mp="2u6qrrw8p6hrx">
        <CardContent className="pt-6" data-id="element-2546" data-mp="2u5ywynmxco2p">
          <table className="text-sm w-full" data-id="element-2547" data-mp="2yz1pqtjvnthu">
            <tbody data-id="element-2548" data-mp="2z032r3kgeq27">
              <tr className="border-b border-slate-100" data-id="element-2549" data-mp="2z0mhycipz0cj">
                <td className="py-2 pr-6 font-medium text-slate-700 w-36 align-top" data-id="element-2550" data-mp="21imfgrvmf6g9">
                  Name
                </td>
                <td className="py-2 text-slate-900" data-id="element-2551" data-mp="26gecg0b4hirb">Section {id ?? '3'}</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2552" data-mp="1ywvjb1860950">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2553" data-mp="1u0wp2x05nwwo">
                  Small Description
                </td>
                <td className="py-2 text-slate-900" data-id="element-2554" data-mp="1p2v7kgido5nb"></td>
              </tr>
              <tr data-id="element-2555" data-mp="1kyf38joex6a7">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2556" data-mp="1kyx9m94sh0vu">
                  Full Description
                </td>
                <td className="py-4 text-slate-800 leading-relaxed max-w-2xl" data-id="element-2557" data-mp="1b9ne0jaql02z">
                  <div className="space-y-3 text-sm" data-id="element-2558" data-mp="1b7kdh5byjok0">
                    {fullDescription.split('\n\n').map((para, i) => {
                    if (para.startsWith('[Question')) {
                      return <p key={i} className="text-slate-500 italic" data-id="element-2559" data-mp="x9ckf8i1l7e4">
                            {para}
                          </p>;
                    }
                    if (para.startsWith('No,')) {
                      return <p key={i} data-id="element-2560" data-mp="ip9wdhdsxtv8">
                            <strong data-id="element-2561" data-mp="mor3sgcsh131">No,</strong>
                            {para.slice(3)}
                          </p>;
                    }
                    if (para.includes('\n•')) {
                      const lines = para.split('\n');
                      return <div key={i} className="space-y-1" data-id="element-2562" data-mp="11eg7ai8cth6h">
                            {lines.map((line, j) => line.startsWith('•') ? <p key={j} className="pl-4" data-id="element-2563" data-mp="rnv92vwleeo3">
                                  {line}
                                </p> : line && <p key={j} data-id="element-2564" data-mp="wkc2a4infj81">{line}</p>)}
                          </div>;
                    }
                    return <p key={i} data-id="element-2565" data-mp="1p4sqip91v0cd" data-mpi={i}>{para}</p>;
                  })}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>;
}